define('vspot-angular/services/categories-service',[], function () {
    'use strict';

    return ['resources.Categories', function (Categories) {
        return {
            /*
             * Get a list of all the categories for themes and badges.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            query: function() {
                return Categories.query();
            },
            save: function(postData) {
                return Categories.save(postData);
            },
            update: function(postData) {
                return Categories.update(postData);
            },
            delete: function(id) {
                return Categories.delete({
                    id: id
                });
            }
        };
    }];
});

